import React, { useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Spinner,
  FormFeedback,
  Form,
} from "reactstrap";
import Select from "react-select";
import { postRouteConfig } from "../../../helpers/backend_helper";
import { useFormik } from "formik";
import * as Yup from "yup";
import NibbleInput from "../../../components/Fields/NibbleInput";
import dayjs from "dayjs";
import { toast } from "react-toastify";

const ConfigModal = ({
  modal,
  setModal,
  geofences,
  reportConfig,
  completeHandler,
}) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setModal({ ...modal, config: false });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...reportConfig,
    },
    validationSchema: Yup.object({
      startDate: Yup.string("Requerido").nullable(true).required("Requerido"),
      endDate: Yup.string("Requerido").nullable(true).required("Requerido"),
      geofences: Yup.array()
        .min(1, "Selecciona una geocerca.")
        .required("Requerido"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      await save(values);
      setLoading(false);
    },
  });

  const save = async (values) => {
    const today = dayjs().format("YYYY-MM-DD");

    const startDate = dayjs(`${today} ${values.startDate}`, "YYYY-MM-DD HH:mm");
    const endDate = dayjs(`${today} ${values.endDate}`, "YYYY-MM-DD HH:mm");

    if (startDate.isAfter(endDate)) {
      toast.warn("La hora de inicio debe ser menor a la hora fin");
      return;
    }

    const response = await postRouteConfig({
      19: values.startDate,
      20: values.endDate,
      21: values.geofences.map((i) => i.numero).join(","),
    });

    if (completeHandler) completeHandler();
  };

  return (
    <div>
      <Modal isOpen={modal.config}>
        <ModalHeader className="bg-primary">Configurar Filtros</ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            validation.handleSubmit();
            return false;
          }}
        >
          <ModalBody>
            <div className="row">
              <NibbleInput
                md={12}
                label="Hora inicio:"
                fieldName="startDate"
                fieldType="time"
                validation={validation}
              />

              <NibbleInput
                md={12}
                label="Hora fin:"
                fieldName="endDate"
                fieldType="time"
                validation={validation}
              />

              <div className="col-sm-12">
                <label className="form-label">Geocercas:</label>
                <Select
                  className={`form-control ${
                    validation.errors["geofences"] && "is-invalid"
                  }`}
                  classNamePrefix="select"
                  isClearable={true}
                  defaultValue={validation.values.geofences}
                  name="week"
                  placeholder="Geocercas"
                  options={geofences}
                  getOptionLabel={(option) =>
                    `${option.numero} - ${option.name}`
                  }
                  getOptionValue={(option) => `${option.id}`}
                  onChange={(e) => {
                    console.log({ e });
                    validation.setFieldValue("geofences", e);
                  }}
                  isMulti
                />
                <FormFeedback type="invalid">
                  {validation.errors["geofences"]}
                </FormFeedback>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" type="submit" disabled={loading}>
              {loading && <Spinner size="sm"></Spinner>}{" "}
              <i className="fa fa-save"></i> Guardar
            </Button>{" "}
            <Button color="secondary" onClick={handleClose}>
              <i className="fa fa-times"></i> Cerrar
            </Button>
          </ModalFooter>
        </Form>
      </Modal>
    </div>
  );
};

export default ConfigModal;
